import { Alert } from "@mui/material";
export default function WorksheetReportNotice({ missingCosts }: { missingCosts: number }) {
  return (
    <Alert severity={missingCosts ? "warning" : "info"} sx={{ mb: 2 }}>
      Worksheet estimated margins are based on entered costs, not verified net profit.
      {missingCosts > 0 &&
        ` ${missingCosts} worksheet line item(s) in this report have no entered costs. Their sales remain included; their margins are unavailable and excluded from margin totals.`}
    </Alert>
  );
}
